(function($) {
    $(() => {
        
        /* DROPZONE */
        var files = [];
        const filesCount = $('.js-upload-wrapper').data('filescount');
        function initializeContentUpload() {
            $(".js-imageupload").dropzone({
                maxFiles: 1,
                uploadMultiple: false,
                maxFilesize: 5,
                createImageThumbnails: false,
                maxfilesexceeded: function (file) {
                    this.removeAllFiles();
                    this.addFile(file);
                },
                
                url: ajax.dropParam.uploadContent,
                acceptedFiles: ".pdf, .doc, .docx ",
                dictRemoveFile: "Törlés",
                dictCancelUpload: "Mégse",
                dictInvalidFileType: "Hiba történt",
                dictResponseError: "Hiba történt",
                dictFileTooBig: "Túl nagy a fájl",
                sending: function(file, xhr, formData) {
                    formData.append("job_name", $('.js-job-form').data('job'));
                },
                processing: function () {
                   
                },
                success: function (file, response) {
                    const result = JSON.parse(response);
                    file.previewElement.classList.add("dz-success");
                    file["attachment_id"] = result['id'];
                    file["hash"] = result['hash'];
                    files.push(result['id']);
                    $('.js-file-error').removeClass('show');
                },
                error: function (file, response) {
                   
                    file.previewElement.classList.add("dz-error");
                    swal({
                        title: response,
                        text: '',
                        button: 'Ok',
                        icon: 'error',
                    });
                },
                // update the following section is for removing image from library
                addRemoveLinks: true,
                removedfile: function (file) {

                    var attachment_id = file.attachment_id;
                    var hash = file.hash;

                    $.ajax({
                        type: "POST",
                        url: ajax.ajaxurl,
                        data: {
                            action: 'handle_deleted_media',
                            media_id: attachment_id,
                            hash: hash
                        }
                    });

                    files = jQuery.grep(files, function(value) {
                        return value != attachment_id;
                    });
                    $('.dz-message').show();
                    $('.upload-file-name').show();
                    var _ref;
                    return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
                    
                }
            });
        }

        initializeContentUpload();

        /* FORM */
         // front-form
         $('.js-job-form').on('submit', function (e) {
            e.preventDefault();
            const $this = $(this);

            $(this)
                .find('.js-job-btn')
                .prop('disabled', true);
            const formdata = $this.serializeArray();

            $.ajax({
                url: ajax.ajaxurl,
                type: 'POST',
                data: {
                    action: 'job_form',
                    datas: formdata,
                    files,
                    job_name : $('.js-job-form').data('job'),
                },
                success(data) {
                    const result = JSON.parse(data);
                    swal({
                        title: result.title,
                        text: result.message,
                        icon: result.icon,
                        button: 'ok'
                    });
                    if (result.status == 'success') {
                        $('.js-job-form').trigger('reset');
                        
                    }
                }
            }).done(response => {
                $this.find('.js-job-btn').prop('disabled', false);
            });
        });


    });
})(jQuery);
